import styled, { css } from 'styled-components';
import { sizes } from 'style';
import { H2 } from 'components/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 28px;

  @media ${sizes.desktop} {
    flex-direction: row;
  }
`;

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${sizes.desktop} {
    flex: ${({ hasClaims }) => (hasClaims ? '3' : '5')};
  }
`;

export const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${({ hasClaims }) => (hasClaims ? '6' : '0')};
  gap: 16px;
`;

export const Header = styled(H2)`
  font-size: 24px;
  font-weight: 700;

  @media ${sizes.desktop} {
    font-size: 32px;
  }
`;

export const InfoLabel = styled.div``;

export const InfoText = styled.div`
  font-weight: 500;
`;

export const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
